export default class Accordion {
    constructor(container, options = {}) {
        this.container = container;
        this.options = Object.assign({
            alwaysOpen: false,
            activeClasses: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white',
            inactiveClasses: 'text-gray-500 dark:text-gray-400',
            onOpen: (item) => {},
            onClose: (item) => {},
            onToggle: (item) => {},
        }, options);
        this.items = [];
        this.init();
    }

    init() {
        const headings = this.container.querySelectorAll('h2[id]');
        headings.forEach(heading => {
            const button = heading.querySelector('button[aria-controls]');
            if (!button) return;

            const targetId = button.getAttribute('aria-controls');
            const target = this.container.querySelector('#' + targetId);
            if (!target) return;

            const item = {
                id: heading.id,
                headingEl: heading,
                triggerEl: button,
                targetEl: target,
                active: button.getAttribute('aria-expanded') === 'true'
            };
            this.setItemState(item, item.active);
            button.addEventListener('click', () => this.toggleItem(item));

            this.items.push(item);
        });
    }

    setItemState(item, open) {
        // Control display
        if (open) {
            item.targetEl.classList.remove('hidden');
            item.triggerEl.setAttribute('aria-expanded', 'true');
            item.triggerEl.classList.add(...this.options.activeClasses.split(' '));
            item.triggerEl.classList.remove(...this.options.inactiveClasses.split(' '));
            // Rotate icon
            this.rotateIcon(item.triggerEl, true);
        } else {
            item.targetEl.classList.add('hidden');
            item.triggerEl.setAttribute('aria-expanded', 'false');
            item.triggerEl.classList.remove(...this.options.activeClasses.split(' '));
            item.triggerEl.classList.add(...this.options.inactiveClasses.split(' '));
            this.rotateIcon(item.triggerEl, false);
        }
        item.active = open;
    }

    rotateIcon(button, open) {
        const icon = button.querySelector('[data-accordion-icon]');
        if (!icon) return;
        if (open) {
            icon.classList.add('rotate-180');
        } else {
            icon.classList.remove('rotate-180');
        }
    }

    toggleItem(item) {
        if (item.active) {
            this.setItemState(item, false);
            this.options.onClose(item);
        } else {
            if (!this.options.alwaysOpen) {
                this.items.forEach(i => {
                    if (i !== item && i.active) {
                        this.setItemState(i, false);
                        this.options.onClose(i);
                    }
                });
            }
            this.setItemState(item, true);
            this.options.onOpen(item);
        }
        this.options.onToggle(item);
    }
}
